import { __spreadArray } from "tslib";
import { HAFS_PAGES_COUNT } from '../commons/constants';
import { groupBy } from './array';
import { stringToNumber } from './string';
/**
 * Convert a page number into a string and ensure it's a valid page number.
 */
export function getValidPageNumber(number) {
    if (number === void 0) { number = 1; }
    var page = parseInt(String(number));
    return Math.max(1, Math.min(HAFS_PAGES_COUNT, page || 1));
}
/**
 * Convert an array of verses to an object of lines
 * [Verses]
 * to
 * { [lineNumber]: [words of the line] }
 */
export function getLinesByVerses(verses) {
    var mergedWords = verses.flatMap(function (_a) {
        var words = _a.w, verse_data = _a.d;
        var _b = verse_data.split('_').map(stringToNumber), chapter_id = _b[0], verse_number = _b[1];
        return __spreadArray([], words.map(function (_a, index) {
            var text_uthmani = _a.uthmani, line = _a.line, type = _a.type;
            return {
                chapter_id: chapter_id,
                verse_number: verse_number,
                is_start: verse_number === 1 && index === 0,
                text_uthmani: text_uthmani,
                line: line,
                type: type || 'word',
            };
        }), true);
    });
    return groupBy(mergedWords, 'line');
}
